import { useTranslation } from 'react-i18next';

import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';
import { formatDateShortLocalized } from '@/utils/date';
import { parseLocale } from '@/utils/localeFormatters';

import styles from './SmoltReportFooter.module.scss';

interface SmoltReportFooterProps {
    createdAt: Date;
    isLoading?: boolean;
}

export default function SmoltReportFooter(props: SmoltReportFooterProps) {
    const { createdAt, isLoading = false } = props;

    const { t, i18n } = useTranslation();
    const locale = parseLocale(i18n.language);

    const smoltReportLabel = ` ${t('smoltReport.detailView.footerReportLabel')}`;
    const createdAtLabel = `${t('smoltReport.detailView.footerGeneratedLabel')} ${formatDateShortLocalized(createdAt, locale)}`;

    const footerContentLabel = [smoltReportLabel, createdAtLabel].join(' - ');
    return (
        <div className={styles.footerContainer}>
            {isLoading ? (
                <SkeletonBox width="100%" height={24} borderRadius={8} />
            ) : (
                <span>{footerContentLabel}</span>
            )}
        </div>
    );
}
